/** iderp con vista admin en Twilio Fast, Unificado, CRM Alumnos y CRM Alumnos Fast */
export const TWILIO_USUARIOS_ADMIN = [
  334, 3015, 1, 568, 32, 718, 1183, 1258, 2155, 2268, 2269, 2342, 954, 2472,
  2556, 2574, 2230, 2767, 2817, 1312, 2910, 2354, 2493, 1794, 1152, 161, 3042,
  2548, // Valeria Monroy Silva — navegar entre vendedoras en Twilio Fast
]

export function esUsuarioTwilioAdmin (iderp) {
  const id = Number(iderp)
  if (Number.isFinite(id) && TWILIO_USUARIOS_ADMIN.includes(id)) return true
  return TWILIO_USUARIOS_ADMIN.includes(iderp)
}

/**
 * Quién puede reasignar chats en Twilio Fast (icono mdi-account-switch).
 */
export const REASSIGN_TWILIO_FAST = [
  1, 334, 568,
]

export function puedeReasignarTwilioFast (iderp) {
  const id = Number(iderp)
  return Number.isFinite(id) && REASSIGN_TWILIO_FAST.includes(id)
}

/** Recepcionista con todos los planteles INBI/FAST en CRM Alumnos (solo este iderp). */
export const CRM_RECEPCION_TODOS_PLANTELES = [2797, 2781]

export function esRecepcionTodosPlantelesCrm (iderp) {
  const id = Number(iderp)
  return Number.isFinite(id) && CRM_RECEPCION_TODOS_PLANTELES.includes(id)
}
